import React, { useState, useEffect } from 'react'
import InfiniteScroll from "react-infinite-scroller";
import axios from 'axios';

import ImageBox  from '../../Global/ImageBox'
import Spinner from '../../Global/Spinner';

import classes from './RelatedImages.module.css'
import styles from '../../../App.module.css'

function RelatedImages(params) {
    const [relatedImages, setRelatedImages] = useState([]);
    const [hasMore, sethasMore] = useState(true);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/related_images.php?id=${params.id}&page=1&limit=12`)
        .then(response => {
            setRelatedImages(response.data);
            response.data.length < 12 ? sethasMore(false) : sethasMore(true);
            setLoading(true);
        }).catch(error => {
            console.log(error);
        })
    }, [])
    
    const updateData = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/related_images.php?id=${params.id}&page=${page}&limit=8`)
        .then(response => {
            if(response.data.message !== 'No images found') {
                loading && hasMore && setRelatedImages([...relatedImages, ...response.data]);
                setpage(page + 1);

                response.data.length < 8 ? sethasMore(false) : sethasMore(true);
            }else {
                sethasMore(false);
            }
        }).catch(error => {
            console.log(error);
        })
    }
    return (
        <div className="">
            <div className={`${classes.sec_heading} mb-4`}>
                <h4 className='m-0'>Releted Images</h4>
            </div>
            <div className={styles.gallery}>
                {
                    relatedImages && relatedImages.map && <InfiniteScroll
                        pageStart={0}
                        loadMore={updateData}
                        hasMore={hasMore}
                        loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                        className='row'
                    >
                        {
                            relatedImages && relatedImages.map &&  relatedImages.map((image, index) => {
                                return (
                                    <div className={`${styles.item} col-lg-3 col-md-4 col-6 col-sm`} key={index}>
                                            {
                                            ImageBox(image)
                                        }
                                    </div>
                                )
                            })
                        }
                    </InfiniteScroll>
                }
            </div>
        </div>
    )
}

export default RelatedImages